<template>
  <Transition name="toast-fade">
    <div v-if="isVisible" class="app-alert-wrap">
      <div class="alert-box">
        <span>{{ item.title }}</span>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

import { usePopupStore } from '@/stores/popup';
import { PopupItem } from '@/types/components';

const popupStore = usePopupStore();

const props = defineProps<{ item: PopupItem }>();
const isVisible = ref(false); // 1. 노출 상태 관리 변수 추가
onMounted(() => {
  isVisible.value = true; // 2. 마운트되자마면 true로 변경하여 'enter' 애니메이션 유도

  const timerId = setTimeout(() => {
    isVisible.value = false; // 3. 닫기 전 false로 바꿔서 'leave' 애니메이션 유도

    // 4. 애니메이션이 끝난 후(약 400ms) 실제 스토어에서 제거
    setTimeout(() => {
      popupStore.close(props.item.id);
    }, 300);
  }, 1500); // 1초는 너무 짧아 애니메이션이 잘 안 보일 수 있으니 2초 추천

  onUnmounted(() => clearTimeout(timerId));
});
</script>

<style scoped lang="scss">
.app-alert-wrap {
  position: fixed;
  width: 100%;

  bottom: env(safe-area-inset-bottom, 2rem);
  padding: 0 1.25rem 5rem;
  z-index: $z-toast;
  background: transparent;
  .alert-box {
    padding: 1rem 1.25rem;
    width: 100%;
    background: $color-gray-300;
    text-align: center;
    border-radius: $size-l;
    span {
      color: $color-white;
      font-weight: 500;
      white-space: pre-wrap;
      font-size: 15px;
    }
  }
}

/* --- 토스트 애니메이션 로직 --- */

// 1. 나타나고 사라지는 동안의 지속 시간 및 효과
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition:
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.4s ease;
}

// 2. 시작 상태
.toast-fade-enter-from {
  transform: scale(0.7);
  opacity: 0;
}

// 3. 종료 상태 (원래 위치)
.toast-fade-enter-to,
.toast-fade-leave-from {
  transform: scale(1);
  opacity: 1;
}

/* --- 토스트 애니메이션 로직 --- */

// 1. 나타나고 사라지는 동안의 지속 시간 및 효과
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition:
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.4s ease;
}

// 2. 시작 상태
.toast-fade-enter-from {
  transform: scale(0.7);
  opacity: 0;
}

// 3. 종료 상태 (원래 위치)
.toast-fade-enter-to,
.toast-fade-leave-from {
  transform: scale(1);
  opacity: 1;
}
</style>
